import { createAction, ActionType } from 'typesafe-actions';
import { OverlayOptions } from './types';

export const showOverlay = createAction('@OVERLAY/show', action => (id: string, options?: OverlayOptions) =>
    action({ id, options })
);
export const hideOverlay = createAction('@OVERLAY/hide', action => (id: string) => action({ id }));
export const exitContentWithAnimation = createAction('@OVERLAY/contentexit', action => (id: string) => action({ id }));

export const overlayActions = { showOverlay, hideOverlay, exitContentWithAnimation };
export type OverlayActionTypes = ActionType<typeof overlayActions>;
